import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import ContactNumber from './contact-number';
import Icon from './icon';
import {ArrowRightSVG, CheckSVG, ClockSVG, CompleteCheckSVG, SearchSVG, WrenchSVG} from './svgs';

function Event(props) {
  const [isOpen, setIsOpen] = useState(props.active);

  useEffect(() => {
    const {active = false, shouldReset = true} = props;
    const isOpenNext = shouldReset ? active : isOpen;
    setIsOpen(isOpenNext);
  }, [isOpen, props]);

  const toggleOpen = () => setIsOpen(!isOpen);

  const shouldDisplayContactNumber = () => {
    const {
      active,
      repair: {positionState},
    } = props;

    return active && (positionState === 'on_track' || positionState === 'on_site');
  };

  const {
    active,
    customSubviewStyle,
    danger,
    icon,
    subview,
    title,
    repair: {maskedPhoneNumber, technician = {}},
  } = props;

  const EventIcons = {
    check: <CheckSVG />,
    search: <SearchSVG />,
    technician: <WrenchSVG />,
    enroute: <ArrowRightSVG />,
    clock: <ClockSVG />,
    cancel: <WrenchSVG />, // TODO: need an icon for cancelled
    complete: <CompleteCheckSVG />,
  };

  const baseWrapperClass = 'border rounded-lg mb-3 transition-all duration-100';
  const borderColor = danger
    ? 'border-[#f5507e]'
    : active
      ? 'border-primary shadow-xs shadow-[#868d9b]'
      : 'border-border';

  const titleTextColor = danger ? 'text-[#f5507e]' : active ? 'text-primary' : 'text-darker-gray';

  const clickableClass = subview ? 'cursor-pointer' : '';

  const contentBorderColor = danger ? 'border-t-[#f5507e]' : active ? 'border-t-primary' : 'border-t-border';

  return (
    <div className={`${baseWrapperClass} ${borderColor}`}>
      <div
        data-testid="status-title"
        className={`status-update-title ${titleTextColor} text-[18px] font-medium p-[14px] relative align-middle ${clickableClass}`}
        onClick={subview ? toggleOpen : undefined}>
        <span className="flex justify-between">
          <span className="flex gap-2">
            <div className="px-1 flex justify-center items-center">{EventIcons[icon]}</div>
            {typeof title === 'string' ? <span className="inline-block align-middle">{title}</span> : title()}
          </span>
          {subview && (
            <div className="flex items-center">
              <Icon>{isOpen ? 'Close' : 'Open'}</Icon>
            </div>
          )}
        </span>

        {maskedPhoneNumber && shouldDisplayContactNumber() && (
          <ContactNumber maskedPhoneNumber={maskedPhoneNumber} technician={technician} />
        )}
      </div>

      {subview && isOpen ? (
        <div
          className={`status-update-content ${contentBorderColor} text-darker-gray p-6 border-t`}
          style={customSubviewStyle}>
          {subview()}
        </div>
      ) : null}
    </div>
  );
}

Event.propTypes = {
  active: PropTypes.bool,
  customSubviewStyle: PropTypes.object,
  danger: PropTypes.bool,
  icon: PropTypes.string,
  shouldReset: PropTypes.bool,
  subview: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  repair: PropTypes.shape({
    positionState: PropTypes.string,
    maskedPhoneNumber: PropTypes.string,
    technician: PropTypes.object,
  }),
};

Event.defaultProps = {
  active: false,
  customSubviewStyle: {},
  danger: false,
  shouldReset: true,
};

export default Event;
